<div class="keen-slider__slide" [class]="'number-slide' + slideNumber">
  <div class="bg-img">
    <img *ngIf="!imgMetaData" [src]="imageSrc" [attr.loading]="slideNumber === 1 ? null : 'lazy'"
         onerror="this.onerror=null;this.src='../assets/images/no-image.svg'" [alt]="title || 'Restaurant'" />
    <canvas #canvas></canvas>
  </div>
  <div class="slider-content-block">
    <div>
      <h1 class="slider-title" title="{{title}}" *ngIf="title">{{ title }}</h1>
      <h6 class="slider-info" title="{{info}}" *ngIf="info">{{ info }}</h6>
    </div>
    <app-button [id]="'go-to-resturant-btn'" style="display: block;width: max-content;"
                [btnCss]="'btn btn-primary border-white'" [btnTitle]="'Go to Restaurant'" [btnText]="'Go to Restaurant'"
                [routerLink]="['business-detail',resturantId]"></app-button>
  </div>
</div>
